import React, { useEffect, useState } from "react";
import "./Navbar.css";
import { Link, useLocation } from "react-router-dom";

function Navbar() {
    const location = useLocation();
    const [today, setToday] = useState("");
    useEffect(() => {
        const date = new Date().toLocaleDateString();
        setToday(date)
    }, []);
    return (
        <nav>
            <div className="links">
                <Link to="/" className={location.pathname === "/" ? "active" : ""}>
                    <h2>Trip Sheet</h2>
                </Link>
                <Link to="/JobApplication" className={location.pathname === "/JobApplication" ? "active" : ""}>
                    <h2>Jobs</h2>
                </Link>
            </div>
            <div className="companyHeading">
                <h4>{today}</h4>
                <img src="/companyLogo.png" alt="company_logo"></img>                
            </div>
        </nav>
    )
}

export default Navbar;